export default __webpack_public_path__ + "static/media/sd-1-rMAX.f0b5d4f8.avif";